// 登錄頁面翻譯

export const login = {
    title: '登錄',
    email: '郵箱',
    password: '密碼',
    submit: '登錄',
    signInWithGoogle: '使用 Google 登錄',
    continueWithEmail: '使用郵箱繼續',
    enterYourEmail: '輸入您的郵箱',
    sendVerificationCode: '發送驗證碼',
    sending: '發送中...',
    verificationCode: '驗證碼',
    resend: '重新發送',
    resendIn: '重新發送於',
    signIn: '登錄',
    signingIn: '登錄中...',
    byContining: '繼續即表示您同意我們的',
    termsOfService: '服務條款',
    and: '和',
    privacyPolicy: '隱私政策',
    signInToAccount: '登錄您的帳戶',
    freeTrialAvailable: '登錄後可免費試用',
    loginProcessingFailed: '登錄處理失敗，請重試',
    googleLoginFailed: 'Google登錄失敗，請重試',
    resendCodeFailed: '重發驗證碼失敗',
    pleaseEnterEmail: '請輸入您的郵箱',
    sendCodeFailed: '發送驗證碼失敗',
    enterEmailError: '請輸入您的郵箱',
    enterCodeError: '請輸入驗證碼',
    loginFailed: '登錄失敗，請檢查驗證碼',
    referralInvitation: '{referrerName} 邀請您註冊，註冊成功後您將獲得 {bonus} 積分獎勵！',
    accountExistsLoginSuccess: '登录成功！',
    accountExistsNoReferralPoints: '账户已存在，登录成功！',
    loginSuccessful: '登录成功！',
    loginFailedGeneric: '登录失败',
    registrationSuccessful: '注册成功！',
    registrationFailedGeneric: '注册失败',
    loggedOutSuccessfully: '退出登录成功',
    googleLoginSuccessful: 'Google登录成功！',
    googleLoginFailedGeneric: 'Google登录失败',
    googleLoginFailedNoAuthCode: 'Google登录失败 - 未收到授权码',
    googleLoginFailedError: 'Google登录失败',
    googleLoginFailedAccessDenied: '用户取消了Google登录授权'
  };
